/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import MachineFile from './MachineFile';

/**
 * The EditMachineQuery model module.
 * @module model/EditMachineQuery
 * @version 0.0.1
 */
class EditMachineQuery {
    /**
     * Constructs a new <code>EditMachineQuery</code>.
     * @alias module:model/EditMachineQuery
     */
    constructor() { 
        
        EditMachineQuery.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EditMachineQuery</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EditMachineQuery} obj Optional instance to populate.
     * @return {module:model/EditMachineQuery} The populated <code>EditMachineQuery</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EditMachineQuery();

            if (data.hasOwnProperty('serial')) {
                obj['serial'] = ApiClient.convertToType(data['serial'], 'String');
            }
            if (data.hasOwnProperty('type')) {
                obj['type'] = ApiClient.convertToType(data['type'], 'String');
            }
            if (data.hasOwnProperty('owner')) {
                obj['owner'] = ApiClient.convertToType(data['owner'], 'String');
            }
            if (data.hasOwnProperty('data')) {
                obj['data'] = MachineFile.constructFromObject(data['data']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EditMachineQuery</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EditMachineQuery</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['serial'] && !(typeof data['serial'] === 'string' || data['serial'] instanceof String)) {
            throw new Error("Expected the field `serial` to be a primitive type in the JSON string but got " + data['serial']);
        }
        // ensure the json data is a string
        if (data['type'] && !(typeof data['type'] === 'string' || data['type'] instanceof String)) {
            throw new Error("Expected the field `type` to be a primitive type in the JSON string but got " + data['type']);
        }
        // ensure the json data is a string
        if (data['owner'] && !(typeof data['owner'] === 'string' || data['owner'] instanceof String)) {
            throw new Error("Expected the field `owner` to be a primitive type in the JSON string but got " + data['owner']);
        }
        // validate the optional field `data`
        if (data['data']) { // data not null
          MachineFile.validateJSON(data['data']);
        }

        return true;
    }


}



/**
 * @member {String} serial
 */
EditMachineQuery.prototype['serial'] = undefined;

/**
 * @member {String} type
 */
EditMachineQuery.prototype['type'] = undefined;

/**
 * @member {String} owner
 */
EditMachineQuery.prototype['owner'] = undefined;

/**
 * @member {module:model/MachineFile} data
 */
EditMachineQuery.prototype['data'] = undefined;






export default EditMachineQuery;

